export const LIST_PRODUCT_SIZES = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL'];

export const sortBySize = <T>(items: T[], getSize: (item: T) => string): T[] => {
    const getRank = (item: T) => {
        const index = LIST_PRODUCT_SIZES.indexOf(getSize(item).trim().toUpperCase());
        return index === -1 ? LIST_PRODUCT_SIZES.length : index;
    };

    return [...items].sort((a, b) => getRank(a) - getRank(b));
};
